export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10536.bda472ac.jpg";